(function () {
  'use strict';

  angular.module('app').component('banksPage', BanksPageComponent());

  function BanksPageComponent() {
    return {
      bindings: {},
      controller: BanksCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/banks/banks-page.component.html',
    };
  }

  BanksCtrl.$inject = ['UtilService', 'AbilityService', 'BankService', 'LanguageService'];

  function BanksCtrl(UtilService, AbilityService, BankService, LanguageService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_bank_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    // getItems();
    getAdditionalLanguages();

    function getItems(selectedItem) {
      vm.filterCriteria = BankService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      BankService.getBanks(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getItems('');
      });
    }

    function createItem() {
      BankService.openBankModal({}, vm.defaultLanguage, vm.additionalLanguages, 'create', getItems);
    }

    function onShowItem(item, mode) {
      BankService.openBankModal(item, vm.defaultLanguage, vm.additionalLanguages, mode);
    }
  }
})();
